import React, { useState } from 'react';
import './HintModal.css';

const HintModal = ({ isOpen, onClose, onRequestHint, loading, hints = [] }) => {
  if (!isOpen) return null;

  return (
    <div className="hint-modal-overlay" onClick={onClose}>
      <div className="hint-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="hint-modal-header">
          <h2>Få hjelp</h2>
          <button className="hint-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="hint-modal-body">
          {hints.length === 0 ? (
            <p className="hint-intro">
              Trenger du hjelp? Trykk på knappen under for å få et hint. Hintene blir gradvis mer hjelpsomme, men gir ikke bort hele svaret.
            </p>
          ) : (
            <div className="hints-list">
              {hints.map((hint, index) => {
                // Extract hint text - handle both object and string formats
                let hintText = '';
                
                if (typeof hint === 'string') {
                  hintText = hint;
                } else if (hint && typeof hint === 'object') {
                  // Try different possible properties
                  hintText = hint.hint || hint.text || hint.content || hint.message || '';
                  
                  // If still empty, try to get first string value from object
                  if (!hintText && hint !== null) {
                    const values = Object.values(hint);
                    const stringValue = values.find(v => typeof v === 'string' && v.trim().length > 0);
                    hintText = stringValue || '';
                  }
                  
                  // Last resort: convert to string, but avoid "[object Object]"
                  if (!hintText) {
                    hintText = String(hint);
                    if (hintText === '[object Object]') {
                      hintText = 'Hint tekst ikke tilgjengelig';
                    }
                  }
                } else {
                  hintText = String(hint || '');
                }
                
                return (
                  <div key={index} className="hint-item">
                    <div className="hint-number">Hint {index + 1}</div>
                    <div className="hint-text">{hintText}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="hint-modal-footer">
          <button 
            className="hint-request-btn" 
            onClick={onRequestHint}
            disabled={loading}
          >
            {loading ? 'Genererer hint...' : `Få hint ${hints.length + 1}`}
          </button>
          <button className="hint-close-btn" onClick={onClose}>
            Lukk
          </button>
        </div>
      </div>
    </div>
  );
};

export default HintModal;
